var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.cellError)?_c('BTooltip',{attrs:{"target":_vm.cellError.target,"placement":"rightbottom","custom-class":"handsontable-error-tooltip"}},[_c('p',[_vm._v(_vm._s(_vm.$t('Fehler')))]),_c('p',[_vm._v(_vm._s(_vm.cellError.errorUserMessage))]),_c('FontAwesomeIcon',{attrs:{"icon":"exclamation-square"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }